import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { XHRBackend, RequestOptions, Http} from '@angular/http';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Camera } from '@ionic-native/camera';
import { FCM } from '@ionic-native/fcm';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { Geolocation } from '@ionic-native/geolocation';
import { Device } from '@ionic-native/device';

import { AgmCoreModule,GoogleMapsAPIWrapper } from '@agm/core';
import { ChartsModule } from 'ng2-charts';
import { AgmDirectionModule } from 'agm-direction';
import { JwtHelper} from 'angular2-jwt';
import { Badge } from '@ionic-native/badge';

import { 
  AuthProvider,
  GlobalServiceProvider,
  StorageServiceProvider,
  UserServiceProvider, 
  CustomerServiceProvider, 
  HttpServiceProvider, 
  NewOrderServiceProvider,
  VideosProvider,
  SilosServiceProvider,
  CameraService,
  FbProvider
} from '../providers/index';

import { IncidentServiceProvider } from '../providers/incident-service/incident-service';
import { ContactServiceProvider } from '../providers/contact-service/contact-service';
import { HistoryServiceProvider } from '../providers/history-service/history-service'; 
import { SettingsServiceProvider } from '../providers/settings-service/settings-service';
import { PipesModule } from '../pipes/pipes.module';
import { WeeklyNewsProvider } from '../pages/weekly-news/weekly-news-service';
import { FmcServiceProvider } from '../providers/fmc-service/fmc-service';
import { HttpClientModule } from '@angular/common/http';
import { FileTransfer } from '@ionic-native/file-transfer';
import { IxomProvider } from '../providers/ixom/ixom';
import { ScheduleAllModule } from '@syncfusion/ej2-angular-schedule';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { MessageSeviceProvider } from '../providers/message-sevice/message-sevice';
import { IxomM2xProvider } from '../providers/ixom-m2x/ixom-m2x';
import { NewDashboardServiceProvider } from '../pages/M2XV2/new-dashboard/new-dashboard-service';
import { M2Xv2ServiceProvider } from '../pages/M2XV2/m2x-v2-service';
console.log('socketURL: ', GlobalServiceProvider.socketURL)
// const socketIoURL = GlobalServiceProvider.isTest ? 'https://bss.boothtransport.com:5001' : 'https://bss.boothtransport.com:5001/prod';
const socketIoURL = GlobalServiceProvider.socketURL;
const config: SocketIoConfig = { url: socketIoURL, options: {}};
@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    AgmCoreModule.forRoot({ 
      apiKey: 'AIzaSyB8BmgssBoOdh8bSXBqZdWjW4-4i4NSfLY', // from BTcustomer
      //apiKey: 'AIzaSyCdFadmO5zsdiDMLdI74RjoanbKed3MLRw', // from BTStaff3
      libraries: ["places"]
    }),
    AgmDirectionModule,
    ChartsModule,
    IonicModule.forRoot(MyApp, {
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition',
      menuType: 'push',
      platforms: {ios: {menuType: 'push'}}
      }),
      PipesModule,
      ScheduleAllModule,
      SocketIoModule.forRoot(config)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {
      provide: Http,
      useFactory: (backend: XHRBackend, options: RequestOptions) => {
        return new HttpServiceProvider(backend, options);
      },
      deps: [XHRBackend, RequestOptions]
    },
    AuthProvider,
    JwtHelper,
    GlobalServiceProvider,
    StorageServiceProvider,
    UserServiceProvider,   
    CustomerServiceProvider,
    Geolocation,
    HttpServiceProvider,
    IncidentServiceProvider,
    ContactServiceProvider,
    NewOrderServiceProvider,
    VideosProvider,
    Camera,
    CameraService,
    AgmCoreModule,
    GoogleMapsAPIWrapper,
    SilosServiceProvider,   
    HistoryServiceProvider,
    File,
    FileOpener,
    FileTransfer,
    SettingsServiceProvider,
    FCM,
    Device,
    FbProvider,
    WeeklyNewsProvider,
    Badge,
    FmcServiceProvider,
    IxomProvider,
    MessageSeviceProvider,
    IxomM2xProvider,
    NewDashboardServiceProvider,
    M2Xv2ServiceProvider
  ],
  schemas:  [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts